var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeminiSparkleRed4Ed1Cbfcbc6C9E84C31B987Da73Fc4168Aec8445(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.0196C14.6358 10.3431 10.3431 14.6358 10.0196 20H9.98042C9.65687 14.6358 5.36425 10.3431 0 10.0196V9.98043C5.36425 9.65688 9.65687 5.36424 9.98042 0H10.0196C10.3431 5.36424 14.6358 9.65688 20 9.98043V10.0196Z",
    fill: "url(#paint0_radial_809_11874)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_809_11874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.13727 9.97493) scale(21.6266 172.607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385135,
    stopColor: "#9E72BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734299,
    stopColor: "#D65C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931035,
    stopColor: "#D6635C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiSparkleRed4Ed1Cbfcbc6C9E84C31B987Da73Fc4168Aec8445);
export default __webpack_public_path__ + "static/media/gemini_sparkle_red_4ed1cbfcbc6c9e84c31b987da73fc4168aec8445.c97d6f50d4e9d3da854329f4c8cf0597.svg";
export { ForwardRef as ReactComponent };